import dateFnsFormat from 'date-fns/format';

import {
  DEFAULT_EMPTY,
  DEFAULT_LOCALE,
  DEFAULT_TEMPLATE,
  DEFAULT_TIMEZONE,
} from '../constants';
import { longDateFormats } from '../constants';
import { IFormat } from '../interfaces';
import { fromTimeZoneToUTC, fromUTCToTimeZone, toDate } from './transform';

export const format: any = (options: IFormat) => {
  const {
    value,
    timeZone = DEFAULT_TIMEZONE,
    locale = DEFAULT_LOCALE,
    template = DEFAULT_TEMPLATE,
    empty = DEFAULT_EMPTY,
  } = options;

  const templates = longDateFormats[locale];

  const localeTemplate = templates.hasOwnProperty(template)
    ? templates[template]
    : template;

  if (Array.isArray(value)) {
    return value.map(v =>
      format({
        value: v,
        timeZone,
        locale,
        template,
        empty: '*',
      })
    );
  }
  if (!value) {
    return empty;
  }
  const valueDate = toDate(value);
  const valueWithTimeZone =
    timeZone === 'utc'
      ? fromUTCToTimeZone(valueDate, timeZone)
      : timeZone === 'local'
      ? valueDate
      : fromTimeZoneToUTC(valueDate, timeZone);

  return dateFnsFormat(valueWithTimeZone, localeTemplate);
};
